import React from "react";
import {
  ContainerSemProduto,
  TitleSemProduto,
  DescriptionSemProduto,
} from "./styles";

const SemProduto = () => {
  return (
    <ContainerSemProduto>
      <TitleSemProduto variant="headline-06" align="left">
        Não foi possível registrar o comunicado de sinistro.
      </TitleSemProduto>
      <DescriptionSemProduto variant="body01-lg" align="left">
        Por favor, entre em contato com a Central de Assistências Dia & Noite e
        Sinistros no 0800 722 2492, de segunda a sexta-feira, das 8h às 18h
        (exceto feriados nacionais).
      </DescriptionSemProduto>
    </ContainerSemProduto>
  );
};
export default SemProduto;
